// Inline JavaScript
const dropzone = document.getElementById('softpulse-dropzone');
const fileInput = document.getElementById('softpulse-fileInput');
const uploadBtn = document.querySelector('.softpulse-upload-btn');
const fileList = document.getElementById('softpulse-fileList');
const form = document.getElementById('softpulse-form');
const phoneInput = document.getElementById('softpulse-phone');


// Prevent default drag behaviors
['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
    dropzone.addEventListener(eventName, preventDefaults, false);
    document.body.addEventListener(eventName, preventDefaults, false);
});

// Handle drag events
['dragenter', 'dragover'].forEach(eventName => {
    dropzone.addEventListener(eventName, highlight, false);
});

['dragleave', 'drop'].forEach(eventName => {
    dropzone.addEventListener(eventName, unhighlight, false);
});

// Handle file events
dropzone.addEventListener('drop', handleDrop, false);
uploadBtn.addEventListener('click', () => fileInput.click());
fileInput.addEventListener('change', handleFiles, false);

function preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
}

function highlight(e) {
    dropzone.classList.add('softpulse-dragover');
}

function unhighlight(e) {
    dropzone.classList.remove('softpulse-dragover');
}

function handleDrop(e) {
    const dt = e.dataTransfer;
    const files = dt.files;
    handleFiles(files);
}

function handleFiles(files) {
    files = files.target?.files || files;
    [...files].forEach(file => {
        if (!file.type.startsWith('image/')) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const fileItem = document.createElement('div');
            fileItem.classList.add('softpulse-file-item');
            fileItem.innerHTML = `
                <img src="${e.target.result}" alt="${file.name}">
                <span class="softpulse-remove-file">&times;</span>
            `;
            fileList.appendChild(fileItem);

            fileItem.querySelector('.softpulse-remove-file').addEventListener('click', () => {
                fileItem.remove();
            });
        };
        reader.readAsDataURL(file);
    });
}

form.addEventListener('submit', async (e) => {
    e.preventDefault();
    let target_btn = e.target.querySelector("button[type='submit']");
    target_btn.innerText = "Submitting...";
    let formData = new FormData(form);
    formData.enctype = "multipart/form-data";
    const files = fileInput.files;
    for (let i = 0; i < files.length; i++) {
        formData.append(`images[]`, files[i]);
    }
    console.log(document.getElementById('softpulse-firstName'))
    // Dynamically set payload values from form inputs
    formData.set('first_name', document.getElementById('softpulse-firstName').value);
    formData.set('last_name', document.getElementById('softpulse-lastName').value);
    formData.set('email', document.getElementById('softpulse-email').value);
    formData.set('mobile_number', document.getElementById('softpulse-phone').value);
    formData.set('product_type', document.getElementById('softpulse-productType').value);
    formData.set('country', document.getElementById('softpulse-country').value);
    formData.set('recycling_items', document.getElementById('softpulse-recyclingItems').value);
    formData.set('address', document.getElementById('softpulse-address').value);

    try {
        const response = await fetch('https://app.bearbirches.com/api/recycle-jean-submission', {
            method: 'POST',
            body: formData
        });

        if (response.ok) {
            target_btn.innerText = "Submit";
            softpulseAlert('success', 'Operation successful!');
            form.reset(); // Reset the form
            fileList.innerHTML = ''; // Clear the file list
        } else {
            target_btn.innerText = "Submit";
            softpulseAlert('danger', 'Something went wrong!');
        }
    } catch (error) {
        console.error('Error:', error);
        softpulseAlert('danger', 'Something went wrong!');
    }
});


function showPopup() {
    document.getElementById('softpulse-popup-overlay').style.display = 'flex';
}
function closePopup() {
    document.getElementById('softpulse-popup-overlay').style.display = 'none';
}

function softpulseAlert(type, message) {
    const alertContainer = document.getElementById('softpulse-alert-container');
    const alertBox = document.createElement('div');
    alertBox.className = `softpulse-alert softpulse-alert-${type}`;
    alertBox.innerHTML = `${message} <button onclick="this.parentElement.remove()">&times;</button>`;
    alertContainer.appendChild(alertBox);
    
    setTimeout(() => {
        alertBox.remove();
    }, 1000 * 10);
}